import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import jenniferSands from "../../assets/img/jennifer-sands.png";
import paulGilbert from "../../assets/img/paul-gilbert.png";
import christopherWarren from "../../assets/img/christopher-warren.png";
import emilyClark from "../../assets/img/emily-clark.png";
import cobyBrandt from "../../assets/img/coby-brandt.png";
import richardMatthews from "../../assets/img/richard-matthews.png";
import kateHudson from "../../assets/img/kate-hudson.png";
import sebastianMartinez from "../../assets/img/sebastian-martinez.png";
import mandynicole from "../../assets/img/mandy-nicole.png";
import { TabContainer } from "./TabFuncionCom";
import HomeTabLTLottie from "../lottie/Home/HomeTabLTLottie";
import HomeTabBSLottie from "../lottie/Home/HomeTabBSLottie";
import HomeTabSnRLottie from "../lottie/Home/HomeTabSnRLottie";
import HomeTabVLLottie from "../lottie/Home/HomeTabVLLottie";
import HomeTabInteractionLottie from "../lottie/Home/HomeTabInteractionLottie";
import HomeTabVoiceLottie from "../lottie/Home/HomeTabVoiceLottie";
import HomeTabVCLottie from "../lottie/Home/HomeTabVCLottie";
import HomeTabCompilerLottie from "../lottie/Home/HomeTabCompilerLottie";
import HomeTabProgramsLottie from "../lottie/Home/HomeTabProgramsLottie";

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%"
  }
});

class LandingTab extends React.Component {
  state = {
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <section className="landing-tab p-t-100 p-b-100">
        <div className="container">
          <div className={classes.root}>
            <AppBar position="static" color="default" className="custom-tab">
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
              >
                <Tab label="Research Backed" />
                <Tab label="Fun & Interactive" />
                <Tab label="Additional Benefits" />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={this.state.value}
              onChangeIndex={this.handleChangeIndex}
            >
              <TabContainer history={this.props.history} dir={theme.direction}>
                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabLTLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          Learning Technique
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Programming Hub offers research backed combination of
                          Kolb's learning technique + insights from experts
                          which ensures you learn thoroughly.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/jennifer-sands.webp")}, ${require("../../assets/webp/jennifer-sands@2x.webp")} 2x, ${require("../../assets/webp/jennifer-sands@3x.webp")} 3x`}
                              />

                              <img
                                src={jenniferSands}
                                srcSet={`${require("../../assets/img/jennifer-sands@2x.png")} 2x,
                        ${require("../../assets/img/jennifer-sands@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Jennifer Sands"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Jennifer Sands{" "}
                            <span className="light">| Business Analyst</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          A truly awesome app for learning programming and
                          getting certifications in courses in an easy and fun
                          way. It’s the best app to learn programming and it’s
                          free.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">Bite Sized</h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          The content is made precise and bite-sized for you to
                          understand quickly learn faster.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/paul-gilbert.webp")}, ${require("../../assets/webp/paul-gilbert@2x.webp")} 2x, ${require("../../assets/webp/paul-gilbert@3x.webp")} 3x`}
                              />
                              <img
                                src={paulGilbert}
                                srcSet={`${require("../../assets/img/paul-gilbert@2x.png")} 2x,
                        ${require("../../assets/img/paul-gilbert@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Paul Gilbert"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Paul Gilbert{" "}
                            <span className="light">| UI Developer</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          I have found this app of great help as it has short
                          and sweet lessons on all programming languages. This
                          helps me in learning programming faster and it’s super
                          easy to understand.
                        </h5>
                      </blockquote>
                    </div>

                    <div className="col-5">
                      <HomeTabBSLottie />
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabSnRLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          Simplification and retention
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Complex concepts are broken down and simplified for
                          better understanding. The learning model ensures 40%
                          higher retention of concepts learned.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/christopher-warren.webp")}, ${require("../../assets/webp/christopher-warren@2x.webp")} 2x, ${require("../../assets/webp/christopher-warren@3x.webp")} 3x`}
                              />
                              <img
                                src={christopherWarren}
                                srcSet={`${require("../../assets/img/christopher-warren@2x.png")} 2x,
                        ${require("../../assets/img/christopher-warren@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Christopher Warren"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Christopher Warren{" "}
                            <span className="light">| Web Developer</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          There is no programming language one cannot learn with
                          this App, the lessons have been simplified and thus
                          understanding of concepts is crytsal clear.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>
              </TabContainer>
              <TabContainer history={this.props.history} dir={theme.direction}>
                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabVLLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          Visual Learning
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Our courses include thousands of illustrations which
                          enhance the learning experience and make it fun.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/richard-matthews.webp")}, ${require("../../assets/webp/richard-matthews@2x.webp")} 2x, ${require("../../assets/webp/richard-matthews@3x.webp")} 3x`}
                              />

                              <img
                                src={richardMatthews}
                                srcSet={`${require("../../assets/img/richard-matthews@2x.png")} 2x,
                        ${require("../../assets/img/richard-matthews@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Richard Matthews"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Richard Mathews{" "}
                            <span className="light">
                              | Database Administrator
                            </span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          As a beginner, I love graphics and color schemes. And
                          this app has beautiful and creative pictures in each
                          course which makes it interesting and joyful to learn.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">Interactions</h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Various types of interactive quizzes and puzzles make
                          the experience unique and joyous.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/coby-brandt.webp")}, ${require("../../assets/webp/coby-brandt@2x.webp")} 2x, ${require("../../assets/webp/coby-brandt@3x.webp")} 3x`}
                              />
                              <img
                                src={cobyBrandt}
                                srcSet={`${require("../../assets/img/coby-brandt@2x.png")} 2x,
                        ${require("../../assets/img/coby-brandt@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Coby Brandt"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Coby Brandt
                            <span className="light">
                              | Mobile Applications Developer
                            </span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          It took me just 15 minutes to understand the loops and
                          statements concept with quizzes and puzzles. This is
                          one of the unique features of the app.
                        </h5>
                      </blockquote>
                    </div>

                    <div className="col-5">
                      <HomeTabInteractionLottie />
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabVoiceLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          Voice and More
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Learn with additional audio and gifs which makes the
                          content come to life.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/emily-clark.webp")}, ${require("../../assets/webp/emily-clark@2x.webp")} 2x, ${require("../../assets/webp/emily-clark@3x.webp")} 3x`}
                              />
                              <img
                                src={emilyClark}
                                srcSet={`${require("../../assets/img/emily-clark@2x.png")} 2x,
                        ${require("../../assets/img/emily-clark@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Emily Clark"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Emily Clark{" "}
                            <span className="light">| Software Designer</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          I love the Audio feature as it makes you feel the
                          teacher is explaining to you. This way, I never get
                          bored of this app, it’s simply amazing.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>
              </TabContainer>
              <TabContainer history={this.props.history} dir={theme.direction}>
                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabVCLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          Verified Certificates
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Get verified e-certificate at completion of each
                          course. You can share the certificate on your resume
                          and popular platforms such as LinkedIn.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/mandy-nicole.webp")}, ${require("../../assets/webp/mandy-nicole@2x.webp")} 2x, ${require("../../assets/webp/mandy-nicole@3x.webp")} 3x`}
                              />
                              <img
                                src={mandynicole}
                                srcSet={`${require("../../assets/img/mandy-nicole@2x.png")} 2x,
                        ${require("../../assets/img/mandy-nicole@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Mandy Nicole"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Mandy Nicole{" "}
                            <span className="light">| Web Developer</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          The biggest advantage is the certificates at the end
                          of each course which help in one’s career and are very
                          important when applying for job in the dream company.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">
                          5000+ Programs
                        </h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          A huge repository of 5000+ programs in over 25
                          programming languages to refer and learn.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/sebastian-martinez.webp")}, ${require("../../assets/webp/sebastian-martinez@2x.webp")} 2x, ${require("../../assets/webp/sebastian-martinez@3x.webp")} 3x`}
                              />
                              <img
                                src={sebastianMartinez}
                                srcSet={`${require("../../assets/img/sebastian-martinez@2x.png")} 2x,
                        ${require("../../assets/img/sebastian-martinez@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Sebastian Martinez"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Sebastian Martinez{" "}
                            <span className="light">
                              | Business System Analyst
                            </span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          What makes Programming Hub stand out from all other
                          apps is a huge library of solved examples and code
                          snippets to practice and master the language.
                        </h5>
                      </blockquote>
                    </div>

                    <div className="col-5">
                      <HomeTabProgramsLottie />
                    </div>
                  </div>
                </section>

                <section className="m-t-100">
                  <div className="row">
                    <div className="col-5">
                      <HomeTabCompilerLottie />
                    </div>
                    <div className="col-7 d-flex flex-column align-items-end">
                      <div className="mb-auto">
                        <h2 className="h2 text-grey semi-bold">Compiler</h2>
                        <h4 className="h4 light text-light-grey m-t-20">
                          Compiler for 24+ programming languages to practice and
                          write your own code and run it without any additional
                          software.
                        </h4>
                      </div>

                      <blockquote className="blockquote m-t-20">
                        <div className="avatar d-flex align-items-center m-b-20">
                          <div className="icon m-r-20">
                            <picture>
                              <source
                                type="image/webp"
                                srcSet={`${require("../../assets/webp/kate-hudson.webp")}, ${require("../../assets/webp/kate-hudson@2x.webp")} 2x, ${require("../../assets/webp/kate-hudson@3x.webp")} 3x`}
                              />
                              <img
                                src={kateHudson}
                                srcSet={`${require("../../assets/img/kate-hudson@2x.png")} 2x,
                        ${require("../../assets/img/kate-hudson@3x.png")} 3x`}
                                className="img-fluid"
                                alt="Kate Hudson"
                              />
                            </picture>
                          </div>
                          <h5 className="h5 semi-bold text-light-grey">
                            Kate Hudson{" "}
                            <span className="light">| iOS Developer</span>
                          </h5>
                        </div>
                        <h5 className="h5 light text-light-grey">
                          Practice makes us perfect. And the in-built compiler
                          makes it easier to practice the codes and learn the in
                          demand programming languages. A must-have for IT
                          people.
                        </h5>
                      </blockquote>
                    </div>
                  </div>
                </section>
              </TabContainer>
            </SwipeableViews>
          </div>
        </div>
      </section>
    );
  }
}

LandingTab.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(LandingTab);
